/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

import { BillingFrequency } from '../enum_properties.js';
import { FlowType } from '../enum_properties.js';
import { Origin } from '../enum_properties.js';
export const v3_CONTEXT = { protocols: { event_version: 3 } };

export class v3_SubscriptionBillingFrequency_SubmittedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'billing_frequency',
            'origin',
            'plan_price_amount',
            'plan_price_currency',
        ]);
        var fixedNumber = 0;

        if (
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        fixedNumber = canFixNumber(this.payload.plan_price_amount);
        if (fixedNumber === false) {
            console.error('plan_price_amount must be of type Number');
        } else {
            this.payload.plan_price_amount = fixedNumber;
        }
        if (
            !(
                typeof this.payload.plan_price_currency === 'string' ||
                this.payload.plan_price_currency instanceof String
            )
        ) {
            console.error('plan_price_currency must be of type String');
        }
        if (this.payload.discount != null) {
            fixedNumber = canFixNumber(this.payload.discount);
            if (fixedNumber === false) {
                console.error('discount must be of type Number');
            } else {
                this.payload.discount = fixedNumber;
            }
        }
        if (
            this.payload.tier_plan != null &&
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            this.payload.tier_type != null &&
            !(
                typeof this.payload.tier_type === 'string' ||
                this.payload.tier_type instanceof String
            )
        ) {
            console.error('tier_type must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'billing_frequency',
            'origin',
            'plan_price_amount',
            'plan_price_currency',
            'discount',
            'tier_plan',
            'tier_type',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionDetails_ViewedProperties {
    static Variation = {
        activeSubscription: 'active_subscription',
        inactiveSubscription: 'inactive_subscription',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['variation']);
        var fixedNumber = 0;

        if (
            !Object.values(
                v3_SubscriptionDetails_ViewedProperties.Variation
            ).includes(this.payload.variation)
        ) {
            console.error('Invalid variation value');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }
        if (
            this.payload.tier_plan != null &&
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            this.payload.tier_type != null &&
            !(
                typeof this.payload.tier_type === 'string' ||
                this.payload.tier_type instanceof String
            )
        ) {
            console.error('tier_type must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'variation',
            'billing_frequency',
            'origin',
            'tier_plan',
            'tier_type',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionPlanConfirm_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
            'flow_type',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionPlanDetails_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_type',
        ]);
        var fixedNumber = 0;

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_type === 'string' ||
                this.payload.tier_type instanceof String
            )
        ) {
            console.error('tier_type must be of type String');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_type',
            'billing_frequency',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionPlanDetails_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_type',
        ]);
        var fixedNumber = 0;

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_type === 'string' ||
                this.payload.tier_type instanceof String
            )
        ) {
            console.error('tier_type must be of type String');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_type',
            'billing_frequency',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionPlanNextSteps_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
            'flow_type',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionPlan_ClickedProperties {
    static PageVersion = {
        oldTier: 'old_tier',
        pilotPlan: 'pilot_plan',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.page_version != null &&
            !Object.values(
                v3_SubscriptionPlan_ClickedProperties.PageVersion
            ).includes(this.payload.page_version)
        ) {
            console.error('Invalid page_version value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
            'flow_type',
            'page_version',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}
export class v3_SubscriptionPlan_SubmittedProperties {
    static PageVersion = {
        oldTier: 'old_tier',
        pilotPlan: 'pilot_plan',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.page_version != null &&
            !Object.values(
                v3_SubscriptionPlan_SubmittedProperties.PageVersion
            ).includes(this.payload.page_version)
        ) {
            console.error('Invalid page_version value');
        }
        if (this.payload.plan_price_amount != null) {
            fixedNumber = canFixNumber(this.payload.plan_price_amount);
            if (fixedNumber === false) {
                console.error('plan_price_amount must be of type Number');
            } else {
                this.payload.plan_price_amount = fixedNumber;
            }
        }
        if (
            this.payload.plan_price_currency != null &&
            !(
                typeof this.payload.plan_price_currency === 'string' ||
                this.payload.plan_price_currency instanceof String
            )
        ) {
            console.error('plan_price_currency must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
            'billing_frequency',
            'flow_type',
            'page_version',
            'plan_price_amount',
            'plan_price_currency',
        ]);
    }

    context() {
        return v3_CONTEXT;
    }
}

function validateRequiredProperties(obj, requiredProperties) {
    if (!obj) {
        console.error('Payload is required');
    }
    requiredProperties.forEach((propertyName) => {
        if (obj[propertyName] === undefined || obj[propertyName] === null) {
            console.error(`${propertyName} is required`);
        }
    });
}

function clearProperties(obj, allowedProperties) {
    var newObj = {};
    allowedProperties.forEach((propertyName) => {
        if (obj[propertyName] !== undefined && obj[propertyName] !== null) {
            var property = obj[propertyName];
            if (property instanceof Date) {
                newObj[propertyName] = property.toISOString();
            } else {
                newObj[propertyName] = obj[propertyName];
            }
        }
    });
    return newObj;
}

function isISODateString(string) {
    const regex =
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
    return regex.test(string);
}

function canFixNumber(input) {
    if (input === undefined) return false;
    let str = typeof input === 'number' ? input.toString() : input;
    const sanitizedStr = str.replace(/[, $]/g, '');
    const number = parseFloat(sanitizedStr);

    if (isNaN(number)) {
        return false;
    }

    return number;
}
